module.exports = __webpack_public_path__ + "static/media/ca-dl.dd5aef09.png";